import { currencyDecimalPlaces } from './providers/TierProvider/consts';
export const getExchangeRate = (currency, rates) => {
    const priceRatesIndex = currency.toLowerCase();
    const exchangeRate = rates[priceRatesIndex].amount / 10 ** currencyDecimalPlaces[priceRatesIndex];
    return exchangeRate;
};
